import styled from '@emotion/styled';

export const OptionLabel = styled.span`
    font-size: ${({ theme }) => theme.typography.heading5};
`;
